import React, { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NewSideBar from "../../components/Navigation/NewSideBar";
import { LayoutContext } from "../../utils/contexts/LayoutContext";
import { fetchOneSession } from "../../services/Interviews/sessionService";
import SmashLoader from "../../components/Loader/SmashLoader";

const Session = () => {
  const { sessionId, uuid } = useParams();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);

  const { setPadding } = useContext(LayoutContext);
  useEffect(() => {
    setPadding("p-0");
    return () => setPadding("p-4");
  }, [setPadding]);

  const fetchData = useCallback(
    async (signal) => {
      try {
        setLoading(true);
        const session_result = await fetchOneSession({
          params: { sessionId, interviewId: uuid },
          signal,
        });

        const session_data = session_result.data;

        console.log("data session", session_data);

        setSession(session_data);
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
      }
    },
    [sessionId, uuid]
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
  }, [fetchData]);

  if (loading) {
    return <SmashLoader />;
  }

  return (
    <div className="flex flex-row h-full max-h-main ">
      <NewSideBar />
      <div className="flex flex-col gap-4 w-full overflow-auto p-8">
        <p className="text-2xl font-medium w-fit">Session Detail</p>
      </div>
    </div>
  );
};

export default Session;
